import {state} from "../../state";
import {configuratorState} from "../../state";

const FormatMainMenuData = (mainMenu, mainConfigMenu) => {

/*
  ---------------------------------------------------------------------------
  main menu
*/
  const mainSectionMenu = [];
  
  mainMenu.forEach((item) => {
    mainSectionMenu.push(item)
  });
  
  // build menu - set default
  state.mainSectionNavMenu = {
    // selected:'',
    selected: mainSectionMenu[0],
    menu: mainSectionMenu
  };
  
  
/*
  ---------------------------------------------------------------------------
   main config menu
*/
  const configMenu = [];
  
  mainConfigMenu.forEach((item) => {
    configMenu.push(item)
  });
  
  // build menu - set default
  configuratorState.configSectionNav = {
    selected: configMenu[0].title,
    menu: configMenu
  };
  
};


export default FormatMainMenuData;
